import React from 'react';
import { Form, Formik } from 'formik';
import { Col, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import FormInputField from '../../../common/components/formFields/FormInputField';
import CommonButton from '../../../common/components/CommonButton';
import FormDatePickerField from '../../../common/components/formFields/FormDatePickerField';
import calendarIcon from '../../../assets/img/icons/calendar.svg';

const initialValues = {
  invoiceNumber: '',
  invoiceDateFrom: '',
  invoiceDateTo: '',
};

const InvoiceForm = ({ handleSearch }) => {
  return (
    <>
      <Formik initialValues={initialValues} onSubmit={handleSearch} validateOnBlur={true}>
        {() => (
          <Form noValidate>
            <Row className="d-flex  align-items-center">
              <Col md={12}>
                <Row className="d-flex justify-content-between">
                  <Col md={4}>
                    <FormInputField name="invoiceNumber" label="Number" />
                  </Col>
                  <Col md={3}>
                    <FormDatePickerField
                      name="invoiceDateFrom"
                      label="Date - From"
                      placeholder="DD/MM/YYYY"
                      icon={calendarIcon}
                      iconClassName="calendar-icon"
                    />
                  </Col>
                  <Col md={3}>
                    <FormDatePickerField
                      name="invoiceDateTo"
                      label="Date - To"
                      placeholder="DD/MM/YYYY"
                      icon={calendarIcon}
                      iconClassName="calendar-icon"
                    />
                  </Col>
                  <Col md={2} className="d-flex align-items-end">
                    <CommonButton
                      className="invoice-search-button"
                      type="submit"
                      label="Search"
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );
};
InvoiceForm.propTypes = {
  handleSearch: PropTypes.func.isRequired,
};

export default InvoiceForm;
